import { memo } from 'react';

import { twMerge } from 'tailwind-merge';

export const NavbarDelimiter = memo(function ({ className }: { className?: string }) {
  return (
    <div className={twMerge('bg-v2blueGray-100 w-11 h-px opacity-[0.12] mx-auto', className)} />
  );
});
